export default __webpack_public_path__ + "static/media/link.fd05bb60.svg";